module.exports = __webpack_public_path__ + "static/media/16.1d23b184.jpg";